<template>
  <div class="bg page">
    <div class="register" style="background-image: url('/img/mine/login-bg.png');">
      <div class="head">
        <i class="head-close van-icon van-icon-arrow-left" @click="back()"></i>
        <div class="head-right">
          <a href="javascript:;" @click="toLogin()">{{ $t("auth.login") }}</a>
        </div>
      </div>

      <img src="/img/login/logo2.png" alt="logo" class="logo">

      <form @submit.prevent>
        <div class="ipt">
          <i class="van-icon van-icon-contact" style="color: rgb(153, 153, 153); font-size: 20px;"></i>
          <input
            type="text"
            v-model="username"
            :placeholder="$t('auth.username_place')"
            autocomplete="username"
          >
        </div>

        <div class="ipt">
          <img src="/img/login/mm.png" alt="" class="ipt-icon">
          <input
            :type="passwordType"
            v-model="password"
            :placeholder="$t('auth.pwd_place')"
            autocomplete="new-password"
          >
          <i
            class="van-icon"
            :class="passwordType === 'password' ? 'van-icon-closed-eye' : 'van-icon-eye-o'"
            style="color: rgb(151, 151, 153); font-size: 20px; cursor: pointer;"
            @click="switchPasswordType"
          ></i>
        </div>

        <div class="ipt">
          <img src="/img/login/yqm.png" alt="" class="ipt-icon">
          <input
            type="text"
            v-model="code"
            :placeholder="$t('auth.invite_code_place')"
          >
        </div>
      </form>

      <div class="agreement">
        <van-checkbox v-model="checked" icon-size="16px" checked-color="#7e5678" />
        <span class="agreement-text">{{ $t("auth.agreement_place") }}</span>
      </div>

      <div class="btn" @click="doRegister()">
        {{ $t("auth.register") }}
      </div>

      <div class="lang-bottom" @click="$router.push('/Language')">
        {{ currentLangName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
      username: "",
      password: "",
      code: "",
      passwordType: "password",
      lang: "hk"
    };
  },
  computed: {
    currentLangName() {
      const l = localStorage.getItem("lang") || "hk";
      const map = {
        hk: "繁體中文",
        en: "English",
        tr: "Türkçe"
      };
      return map[l] || "繁體中文";
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toLogin() {
      this.$router.push("Login");
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: localStorage.getItem("lang") || "hk"
        },
        url: "member_register"
      }).then((res) => {
        if (res && res.code === 200) {
          this.$toast.success(res.msg);
          const targetId = (typeof res.data === 'object' && res.data && res.data.id !== undefined) ? res.data.id : res.data;
          localStorage.setItem("token", String(targetId));
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res && res.msg ? res.msg : "網絡請求失敗，請稍後再試");
        }
      });
    }
  },
  created() {
    if (localStorage.getItem("token")) {
      this.$router.push({ path: "/Mine" });
    }
  }
};
</script>

<style scoped lang="less">
.bg.page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 100vh;
  background-image: linear-gradient(180deg, #f560cd, #4f2b8a);
}

.register {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 18.667vw;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100%;
  position: relative;
  z-index: 99;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4% 4%;
}

.head-close {
  font-size: 6.667vw;
  color: #fff;
  cursor: pointer;
}

.head-right a {
  font-size: 4.533vw;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
}

.logo {
  display: block;
  width: 48vw;
  max-width: 46vw;
  margin: 5.333vw auto 0;
}

form {
  margin-top: 5.333vw;
}

.ipt {
  width: 90%;
  height: 14.667vw;
  margin: 3.2vw auto;
  border-radius: 1.333vw;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 5.333vw;
  box-sizing: border-box;
}

.ipt input {
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  padding-left: 3.2vw;
  font-size: 4vw;
  outline: none;
}

.ipt input::placeholder {
  font-size: 4vw;
  color: #999;
}

.ipt-icon {
  width: 5.333vw;
  height: 5.333vw;
  object-fit: contain;
  flex-shrink: 0;
}

.agreement {
  width: 90%;
  margin: 3.2vw auto 0;
  display: flex;
  align-items: center;
  gap: 2vw;
  box-sizing: border-box;
}

.agreement-text {
  font-size: 3.2vw;
  color: #fff;
  line-height: 1.3;
}

.btn {
  width: 90%;
  margin: 6.667vw auto 0;
  background: linear-gradient(135deg, #7d76ef, #d63f8c);
  height: 11.733vw;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 4.533vw;
  font-weight: 600;
  border-radius: 1.333vw;
  cursor: pointer;
}

.lang-bottom {
  position: absolute;
  left: 50%;
  bottom: 6.4vw;
  transform: translateX(-50%);
  padding: 1.6vw 4.8vw;
  font-size: 3.733vw;
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 1.067vw;
  white-space: nowrap;
  cursor: pointer;
}
</style>
